import { Alert, Anchor, Button, Text } from '@cowbell/ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleExclamation,
  faCircleInfo,
} from '@fortawesome/pro-regular-svg-icons';
import { List, ListItem } from '@mantine/core';

import type { SpotlightDetailsPersonaForNavigation } from './spotlightDetails.types';

interface SpotlightDetailsMissingIdAlertProps {
  persona: SpotlightDetailsPersonaForNavigation;
}

export function SpotlightDetailsMissingIdAlert(
  props: SpotlightDetailsMissingIdAlertProps
) {
  const { persona } = props;

  return (
    <Alert
      variant="light"
      color="red"
      icon={<FontAwesomeIcon icon={faCircleExclamation} />}
      mt="md"
    >
      <Text size="md">
        This page needs a valid link. Go back to{' '}
        {persona.isInsured ? 'Insights' : 'Account Details'}
        and open the item again.
      </Text>
    </Alert>
  );
}

interface SpotlightDetailsLoadErrorAlertProps {
  onRetry: () => void;
}

export function SpotlightDetailsLoadErrorAlert(
  props: SpotlightDetailsLoadErrorAlertProps
) {
  const { onRetry } = props;

  return (
    <Alert
      variant="light"
      color="red"
      icon={<FontAwesomeIcon icon={faCircleExclamation} />}
      mt="md"
    >
      <Text size="md" mb="xs">
        We couldn&apos;t load this spotlight.
      </Text>
      <Text size="sm" c="dimmed" mb="xs">
        Check your connection, then tap Try again.
      </Text>
      <Button variant="light" onClick={onRetry}>
        Try again
      </Button>
    </Alert>
  );
}

export function SpotlightDetailsNotFoundAlert() {
  return (
    <Alert
      variant="light"
      color="gray"
      icon={<FontAwesomeIcon icon={faCircleInfo} />}
      mt="md"
    >
      <Text size="md">We couldn&apos;t find this spotlight.</Text>
    </Alert>
  );
}

interface SpotlightDetailsPatchLinkAlertProps {
  vendorAdvisoryLinks: string[];
}

export function SpotlightDetailsPatchLinkAlert(
  props: SpotlightDetailsPatchLinkAlertProps
) {
  const { vendorAdvisoryLinks } = props;

  return (
    <Alert
      variant="default"
      icon={<FontAwesomeIcon icon={faCircleInfo} />}
      mt="md"
      radius="md"
    >
      <Text size="md">Official patch available for this vulnerability:</Text>
      <List>
        {vendorAdvisoryLinks.length > 0 &&
          vendorAdvisoryLinks.map((link) => (
            <ListItem key={link}>
              <Anchor href={link} target="_blank" size="md">
                {link}
              </Anchor>
            </ListItem>
          ))}
      </List>
    </Alert>
  );
}
